import React from 'react'
import PropTypes from 'prop-types'

import { Container, Text } from './styles'

const TextDivisor = ({ text, height }) => {
  return (
    <Container height={height} text={text}>
      {text && <Text>{text}</Text>}
    </Container>
  )
}

TextDivisor.propTypes = {
  text: PropTypes.string,
  height: PropTypes.number,
}

TextDivisor.defaultProps = {
  text: null,
  height: null,
}

export default TextDivisor
